export const getMapFromTierIds = (tierIds, availableTiers = []) => availableTiers.reduce((acc, tier) => {
    return {
        ...acc,
        [tier.id]: tierIds.indexOf(tier.id) !== -1,
    };
}, {});
export const getTierIdsFromMap = (tierIdsMap) => Object.keys(tierIdsMap).reduce((accumulator, key) => (tierIdsMap[key] ? [...accumulator, key] : accumulator), []);
